import { render, staticRenderFns } from "./StickyEmail.vue?vue&type=template&id=107cf3b4&scoped=true&"
import script from "./StickyEmail.vue?vue&type=script&lang=js&"
export * from "./StickyEmail.vue?vue&type=script&lang=js&"
import style0 from "./StickyEmail.vue?vue&type=style&index=0&id=107cf3b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107cf3b4",
  null
  
)

export default component.exports